import styled from 'styled-components'

interface InputProps {
  isFocused: boolean;
  rows?: number;
  isIncorrect?: boolean;
}

export const InputContainer = styled.div<{ width?: string }>`
  width: ${props => props.width ?? '100%'};
  display: flex;
  flex-direction: column;
  small {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #E84242;
  }
`

export const LabelContainer = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
`

export const InputLabel = styled.span<{ labelSize: 'small' | 'high', isIncorrect?: boolean }>`
  color: ${props => props.isIncorrect ? '#E84242' : '#353744'};
  font-weight: 900;
  font-size: ${props => props.labelSize === 'small' ? '14px' : '24px'};
  line-height: ${props => props.labelSize === 'small' ? '21px' : '34px'};
  margin-bottom: ${props => props.labelSize === 'small' ? '0' : '12px'};
`

export const LabelDescription = styled.span<{ labelSize: 'small' | 'high', isIncorrect?: boolean }>`
  color: ${props => props.isIncorrect ? '#E84242' : '#353744'};
  font-weight: 500;
  font-size: ${props => props.labelSize === 'small' ? '12px' : '20px'};
  line-height: ${props => props.labelSize === 'small' ? '21px' : '34px'};
  margin-bottom: ${props => props.labelSize === 'small' ? '0' : '12px'};
`

export const InputBox = styled.div<InputProps>`
  width: 100%;
  min-height: 40px;
  height: ${props => props.rows ? `${24 * props.rows}px` : 'fit-content'};
  border: ${props => props.isIncorrect ? '1px solid #E84242' : props.isFocused ? '2px solid #3D6666' : '1px solid #C8C8C8'};
  background-color: #fff;
  padding-right: 10px;
  display: flex;
  align-items: center;

  select {
    height: 100%;
    width: 100%;
    padding: 6px 21px 6px 16px;
    font-size: 16px;
    line-height: 24px;
    opacity: 0.9;
    color: #52545D;
    border: none;
    background-color: #fff;
  }

  option {
    color: #52545D;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`